module.exports = __webpack_public_path__ + "img/powerOfHabit.48d0a363.png";